import { formatMinorUnits } from '@seek/currency';
import { Inline, Text } from 'braid-design-system';
import { useAppContext } from 'src/App/context/AppContext';
import type { MappedAdProduct } from 'src/mappers/mapProductSetItems';
import { getPriceWithTax } from '../getDisplayPrices';
import { TaxWrapper } from '../TaxWrapper/TaxWrapper';

export const Price = ({
  mappedAdProduct,
  showDiscountInfo,
}: {
  mappedAdProduct: MappedAdProduct;
  showDiscountInfo: boolean;
}) => {
  const { locale, language } = useAppContext();
  const { price } = mappedAdProduct;

  const totalPrice = getPriceWithTax(price, showDiscountInfo);

  return (
    <Inline space="xxsmall" align="right">
      <TaxWrapper locale={locale} tax={price.tax}>
        <Text size="standard" weight="strong">
          {formatMinorUnits(totalPrice, {
            currency: price?.retailPrice.currency,
            locale: language,
          })}
        </Text>
      </TaxWrapper>
    </Inline>
  );
};
